import React, { useState } from "react";
import { TOnChangeInput } from "../../data/AppType";
import { getLocalDate } from "../../utils/AppFunctions";
import { cn } from "../../lib";

export interface ICTimePickerProps {
  value: string;
  onChangeTime?: (event: TOnChangeInput) => void;
  min?: string;
  max?: string;
  errorMessage?: string;
  label?: string;
  containerClassName?: string;
  required?: boolean;
  disabled?: boolean;
}

const ICTimePicker: React.FC<ICTimePickerProps> = (props) => {
  const {
    containerClassName,
    value,
    onChangeTime,
    min,
    max,
    errorMessage,
    label,
    required,
    disabled,
  } = props;
  const [selectedTime, setSelectedTime] = useState<string>(value || "");

  const handleTimeChange = (event: TOnChangeInput) => {
    setSelectedTime(event.target.value);
    if (onChangeTime) {
      onChangeTime(event);
    }
  };

  function getCurrentTime() {
    const now = getLocalDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const formattedHours = hours < 10 ? "0" + hours : hours;
    const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
    const currentTime = `${formattedHours}:${formattedMinutes}`;
    return currentTime;
  }

  return (
    <div className="pt-0 pb-0">
      <div
        className={cn(
          `relative flex items-center border border-muted text-muted rounded-lg appearance-none p-2 !pr-1 bg-transparent h-10
        hover:border-black focus-within:border-accent focus-within:text-accent`,
          {
            "error-border": errorMessage,
            [`${containerClassName}`]: containerClassName,
          }
        )}
      >
        <label
          className={`absolute flex items-center floating-timePicker top-0 text-xs px-1`}
        >
          {label + (required ? "*" : "")}
        </label>
        <input
          className="w-full border-0 outline-none bg-transparent"
          type="time"
          disabled={disabled}
          max={max}
          min={min}
          onChange={handleTimeChange}
          value={selectedTime}
        />
      </div>
      {errorMessage && (
        <div className="text-sm text-danger">{errorMessage}</div>
      )}
    </div>
  );
};
export default ICTimePicker;
